<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="this.$t('management_page.approval_information')")
    b-container(fluid)
      .context.required
        b-form(v-if="list.length > 0")
          b-form-group.d-flex.align-items-center(
            v-for="n in 4"
            :key="n"
            content-cols-sm
            :label="$t('step_n', { n: n })"
            label-for="device-name"
            label-cols-sm="1"
            label-align-sm="left"
            :class="requiredStep >= n ? 'required' : ''"
          )
            .d-flex.align-items-center
              table.info
                colgroup
                  col(width="100")

                  col(width="50")
                  col(width="100")
                  
                  col(width="50")
                  col(width="100")
                tr
                  td 
                    span(v-if="list[n - 1]")
                      b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: list[n - 1].approver_pk}}") {{list[n - 1].approver_name}} ({{list[n - 1].approver_id}})
                    span(v-else) -
                  th {{$t('management_page.approval_status')}}
                  td
                    span(v-if="list[n - 1]") {{  apInStatsCodeString(list[n - 1].apInStatsCode) }}

                  th {{$t('management_page.approval_datetime')}}
                  td
                    span(v-if="list[n - 1]") {{ list[n - 1].proposal_time | moment("YY-MM-DD HH:mm:ss") }}
        span(v-else) {{$t('management_page.no_approval_information')}}
    .modal-footer
      b-button(variant="secondary" size="sm" @click="visible = false" pill) {{$t('submit')}}
</template>

<script>
import { ManagementAPI } from "@/api"
import Dialogs from "@/components/mixins/dialog/index.vue"
import DialogApprover2 from "@/components/user/components/dialogApprover2.vue"
import _ from "lodash"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Dialogs,
    DialogApprover2,
  },
  computed: {
    apInStatsCodeString() {
      return (val) => {
        switch (val) {
          case 1:
            return this.$t('approval')
          case 2:
            return this.$t('reject-submit')
          default:
            return this.$t('management_page.pending')
        }
      }
    },
  },
  watch: {
    show(newVal) {
      this.visible = newVal
      if (newVal) {
        this.fetchList()
      }
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
      requiredStep: 0,
      list: [],
    }
  },
  methods: {
    fetchList() {
      const params = this.form
      ManagementAPI.manager.get("authorization-info", { params }).then(res => {
        const { objects } = res.data
        this.list = _.orderBy(objects, ["seq"], ["asc"])
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}
.btn-secondary {
  color: #6f6f6f;
  border-color: #6f6f6f;
  background-color: #fff;
  text-align: center;
}
.info {
  width: 100%;
  th,
  td {
    border: 1px solid #d2d2d2;
    text-align: center;
    height: 36px;
  }
  th {
    background-color: #fafafa;
  }
}
</style>
